import React from 'react';
import {createRoot} from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import './index.css';
import App from './App';


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
      <App />
  );
